import { Controller } from "@hotwired/stimulus";

// Reloads a turbo-frame on an interval until its content reports completion
// or the deadline passes. Builds no DOM — the server renders both the frame
// and the timeout notice (docs/STIMULUS_CONVENTIONS.md); this only decides
// when to ask again and which server-rendered element to reveal.
export default class extends Controller {
  static targets = ["frame", "timeout"];
  static values = { interval: Number, deadline: Number };

  connect() {
    this.startedAt = Date.now();
    this.timer = setInterval(() => this.tick(), this.intervalValue);
  }

  disconnect() {
    this.stop();
  }

  tick() {
    // Queries INSIDE the frame: Turbo replaces the frame's children and
    // discards attributes on the response's frame element, so a marker on
    // the frame itself would never arrive.
    if (this.frameTarget.querySelector("[data-poll-complete]")) {
      this.stop();
      return;
    }

    if (Date.now() - this.startedAt >= this.deadlineValue) {
      this.stop();
      this.giveUp();
      return;
    }

    this.frameTarget.reload();
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  // Reveals the server-rendered notice. It says nothing arrived rather than
  // implying failure — the door may simply not have been opened yet, which is
  // the one thing this page cannot check for itself.
  //
  // The target is optional: this controller's own tests render no notice.
  giveUp() {
    if (this.hasTimeoutTarget) this.timeoutTarget.classList.remove("hidden");
  }
}
